import React from 'react';
import { FISH_HEALTH, fishHealth } from "../../../util/varibles/constants";
import styles from "./style.module.scss";

interface IProps {
    value?: FISH_HEALTH | null
}

const StickerFishHealth: React.FC<IProps> = ({ value }) => {
    if (!value)
        return null;

    const { bg } = fishHealth[value] || {};

    if (!bg)
        return null;

    return <div className={styles.sticker} style={{ borderColor: `${bg} transparent transparent ${bg}` }} />
};

export default StickerFishHealth;